import gbAntSelectMultipleCascader from "./src/gb-ant-select-multiple-cascader.vue";
const gbAntSelectMultipleCascaderCompenet = function(Vue) {
  Vue.component(gbAntSelectMultipleCascader.name, gbAntSelectMultipleCascader);
};
export default gbAntSelectMultipleCascaderCompenet;
